<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// Universal RAW to AVIF converter - supports 20+ camera RAW formats via LibRaw
const converterConfig = parseAndValidateConverterConfig('raw-to-avif-converter', 'RAW → AVIF');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[RAW to AVIF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[RAW to AVIF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[RAW to AVIF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[RAW to AVIF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[RAW to AVIF Converter] Credits updated:', credits);
}
</script>
